export const TREINSERIES_QUERY_KEY = "treinseries";
